import AxiosInterceptor from "../utils/AxiosInterceptor";
import { API_BASE } from "../utils/constants";

export const apiAuth = {
  resetPassword: (value) => AxiosInterceptor().post(API_BASE + "/update-password", value),
  getAdminDetails: (value) => AxiosInterceptor().get(API_BASE + "/getAdminDetails", value),
  updateAdminProfile: (value) => AxiosInterceptor().post(API_BASE + "/editProfile", value),
  changePassword: (value) => AxiosInterceptor().post(API_BASE + "/changePassword", value),
  getSetting: (value) => AxiosInterceptor().get(API_BASE + "/getSettings", value),
  updateSetting: (value) => AxiosInterceptor().post(API_BASE + "/updateSettings", value),
};

export const userServices = {
  getUser: (values) => AxiosInterceptor().post(`/getAllUsers`, values),
  getById: (values) => AxiosInterceptor().post(`/getUserById`, values),
  add: (values) => AxiosInterceptor().post(`/createUser`, values),
  edit: (value) => AxiosInterceptor().post(`/updateUser`, value),
  deleteUser: (value) => AxiosInterceptor().post(`/deleteUser`, value),
  changeStatus: (value) => AxiosInterceptor().post(`/status`, value),
  blockUnblockUser: (value) => AxiosInterceptor().post(`/block-unblock-user`, value),
  getReferById: (values) => AxiosInterceptor().post(`/referal/shared-referal`, values),
  kycStatus: (value) => AxiosInterceptor().post(`/kycStatus`, value),
  archiveUser: (value) => AxiosInterceptor().post(`/archiveUser`, value),
  unarchiveUser: (value) => AxiosInterceptor().post(`/unarchiveUser`, value),
};

export const CustomerSupport = {
  getAll: (values) => AxiosInterceptor().post(`/getAllContactSupportRequests`, values),
  getById: (values) => AxiosInterceptor().post(`/getContactSupportRequestById`, values),
  reply: (values) => AxiosInterceptor().post(`/replyToContactSupport`, values),
  response: (values) => AxiosInterceptor().post(`/contact/send-mail`, values), // Keep old method for backward compatibility
};

export const feedbackServices = {
  getAll: (values) => AxiosInterceptor().post(`/getAllRatings`, values),
  getById: (values) => AxiosInterceptor().post(`/getRatingById`, values),
};

export const subAdminServcie = {
  getUser: (values) => AxiosInterceptor().post(`/getAllSubAdmins`, values),
  getById: (values) => AxiosInterceptor().post(`/getSubAdminById`, values),
  add: (values) => AxiosInterceptor().post(`/createSubAdmin`, values),
  edit: (value) => AxiosInterceptor().post(`/updateSubAdmin`, value),
  deleteUser: (value) => AxiosInterceptor().post(`/deleteSubAdmin`, value),
  changeStatus: (value) => AxiosInterceptor().post(`/updateSubAdminStatus`, value),
};

export const apiOfferBannerManagement = {
  getAll: (values) => AxiosInterceptor().post(`/getAllBanners`, values),
  getById: (values) => AxiosInterceptor().post(`/getBannerById`, values),
  add: (values) => AxiosInterceptor().post(`/createBanner`, values),
  edit: (value) => AxiosInterceptor().post(`/updateBanner`, value),
  deleteBanner: (value) => AxiosInterceptor().post(`/deleteBanner`, value),
  changeStatus: (value) => AxiosInterceptor().post(`/bannerStatus`, value),
  auctionList: (value) => AxiosInterceptor().post(`/auctionList`, value),
};

export const ticketServices = {
  getTicket: (values) => AxiosInterceptor().post(`/ticket/get-all-ticket`, values),
  getById: (values) => AxiosInterceptor().post(`/ticket/get-by-id`, values),
  add: (values) => AxiosInterceptor().post(`/ticket/create-ticket`, values),
  edit: (value) => AxiosInterceptor().post(`/ticket/edit-ticket`, value),
  deleteTicket: (value) => AxiosInterceptor().post(`/ticket/delete-ticket`, value),
  changeStatus: (value) => AxiosInterceptor().post(`/ticket/update-status`, value),

  getCountries: (value) => AxiosInterceptor().post(`/location/countries`, value),
  getStatesByCountry: (value) => AxiosInterceptor().post(`/location/states`, value),
  getCity: (value) => AxiosInterceptor().post(`/location/cities`, value),

};


export const sportsTeamServices = {
  getAll: (values) => AxiosInterceptor().post(`/team/get-all`, values),
  getById: (values) => AxiosInterceptor().post(`/team/get-one`, values),
  add: (values) => AxiosInterceptor().post(`/team/create`, values),
  edit: (value) => AxiosInterceptor().post(`/team/update`, value),
  deleteTicket: (value) => AxiosInterceptor().post(`/team/delete`, value),
  changeStatus: (value) => AxiosInterceptor().post(`/team/status`, value),
};

export const AuctionServices = {
  getAuction: (values) => AxiosInterceptor().post(`/auction/get-All-Auctions`, values),
  getById: (values) => AxiosInterceptor().post(`/auction/get-by-id`, values),
  add: (values) => AxiosInterceptor().post(`/auction/create-auction`, values),
  edit: (value) => AxiosInterceptor().post(`/auction/edit-auction`, value),
  deleteAuction: (value) => AxiosInterceptor().post(`/auction/delete-auction`, value),
  changeStatus: (value) => AxiosInterceptor().post(`/auction/update-status`, value),
  allTickets: (value) => AxiosInterceptor().post(`/auction/slug-with-tickets `, value),
  allAuction: (value) => AxiosInterceptor().post(`/auction/get-auction-details`, value),
  allTcketQuantity: (value) => AxiosInterceptor().post(`/room/ticket/winners`, value),
  BiddingHistory: (value) => AxiosInterceptor().post(`/room/ticket/bid-history-individual`, value),
};

export const bitPackageServices = {
  add: (values) => AxiosInterceptor().post(`/bidPackage/bid-package`, values),
  getBids: (values) => AxiosInterceptor().post(`/bidPackage/get-bid-package`, values),
  getById: (values) => AxiosInterceptor().post(`/bidPackage/get-single-bid-package`, values),
  edit: (value) => AxiosInterceptor().post(`/bidPackage/update-bid-package`, value),
  deleteBid: (value) => AxiosInterceptor().post(`/bidPackage/delete-bid-package`, value),
  changeStatus: (value) => AxiosInterceptor().post(`/bidPackage/update-status`, value),
};

export const emailServices = {
  getEmail: (values) => AxiosInterceptor().post(`/getAllEmailTemplates`, values),
  addEmail: (value) => AxiosInterceptor().post(`/addEmailTemplate`, value),
  getByIdEmail: (values) => AxiosInterceptor().post(`/getEmailTemplate`, values),
  editEmail: (value) => AxiosInterceptor().post(`/addEmailTemplate`, value),
  deleteEmail: (value) => AxiosInterceptor().post(`/deleteEmailTemplate`, value),
  changeStatusEmail: (value) => AxiosInterceptor().post("/emailStatus", value),
};

export const apiCategory = {
  add: (value) => AxiosInterceptor().post(`/createCategory`, value),
  edit: (value) => AxiosInterceptor().post(`/updateCategory`, value),
  delete: (value) => AxiosInterceptor().post(`/deleteCategory`, value),
  getAll: (values) => AxiosInterceptor().post(`/getAllCategory`, values),
  getSubCategory: (values) => AxiosInterceptor().post(`/getsubCategory`, values),
  getById: (values) => AxiosInterceptor().post(`/getCategoryById`, values),
  changeStatus: (value) => AxiosInterceptor().post("/categoryStatus", value),
  getAllSubCategory: (values) => AxiosInterceptor().post(`/subcategory/getAllSubcategories`, values),
  addSubCategory: (value) => AxiosInterceptor().post(`/subcategory/add-subcategory`, value),
  editSubCategory: (value) => AxiosInterceptor().post(`/subcategory/edit-subcategory`, value),
  deleteSubCategory: (value) => AxiosInterceptor().post(`/subcategory/delete-subcategory`, value),
  getByIdSubCategory: (values) => AxiosInterceptor().post(`/category/get-categories-in-parent`, values),
  changeStatusSubCategory: (value) => AxiosInterceptor().post("/subcategory/update-status", value),
  category: (value) => AxiosInterceptor().post("/category/categoriesDropdown", value),

  categorySports: (value) => AxiosInterceptor().post("/category/sports/dropdown", value),

};

export const apiCms = {
  add: (value) => AxiosInterceptor().post(`/addContent`, value),
  edit: (value) => AxiosInterceptor().post(`/updateContent`, value),
  delete: (value) => AxiosInterceptor().post(`/cms/delete`, value),
  getAll: (values) => AxiosInterceptor().post(`/getAllContent`, values),
  getById: (values) => AxiosInterceptor().post(`/getOneContent`, values),
  changeStatus: (value) => AxiosInterceptor().post("/cms/update-status", value),
};

export const AboutUsApi = {
  update: (value) => AxiosInterceptor().post(`/cms/about-us`, value),
  getById: (values) => AxiosInterceptor().get(`/cms/about-us`, values),
}

export const apiAdsBidFree = {
  add: (value) => AxiosInterceptor().post(`/video/create-video`, value),
  edit: (value) => AxiosInterceptor().post(`/video/edit-video`, value),
  delete: (value) => AxiosInterceptor().post(`/video/delete-video`, value),
  getAll: (values) => AxiosInterceptor().post(`/video/get-all-videos`, values),
  getById: (values) => AxiosInterceptor().post(`/video/get-by-id`, values),
  changeStatus: (value) => AxiosInterceptor().post("/video/update-status", value),
};

export const NotificationServices = {
  getNotification: (value) => AxiosInterceptor().get("/setting/get-notifications-setting", value),
  updateStatus: (value) => AxiosInterceptor().post("/updateTemplateStatus", value),
  getAll: (value) => AxiosInterceptor().post("/getAllTemplates", value),
  getById: (value) => AxiosInterceptor().post("/getTemplateById", value),
  update: (value) => AxiosInterceptor().post("/updateTemplate", value),
  create: (value) => AxiosInterceptor().post("/createTemplate", value),
};

export const PlaceBidsServices = {
  getData: (value) => AxiosInterceptor().get("/task/placedBids/get", value),
  update: (value) => AxiosInterceptor().post("/task/dailyBidService", value),
};

export const ShareReferServices = {
  getData: (value) => AxiosInterceptor().get("/task/shareReferal/get", value),
  update: (value) => AxiosInterceptor().post("/task/socialShareReferal", value),
};

export const AutionBidsServices = {
  getData: (value) => AxiosInterceptor().get("/task/purchaseAuctionTask/get", value),
  update: (value) => AxiosInterceptor().post("/task/purchaseAuctionTask", value),
};
export const PaymentServices = {
  getData: (value) => AxiosInterceptor().post("/payments", value),
  update: (value) => AxiosInterceptor().post("/payments/update-status", value),
};
export const DashboardServices = {
  getData: (value) => AxiosInterceptor().post("/complete",value),
};

export const Teams = {
  getData: (value) => AxiosInterceptor().get("/team/dropdown",value),
};

export const TestimonialsServices = {
  add: (values) => AxiosInterceptor().post(`/testimonial/create-testimonial`, values),
  getTestimonial: (values) => AxiosInterceptor().post(`/testimonial`, values),
  getById: (values) => AxiosInterceptor().post(`/testimonial/get-testimonial`, values),
  edit: (value) => AxiosInterceptor().post(`/testimonial/update-testimonial`, value),
  delete: (value) => AxiosInterceptor().post(`/testimonial/delete-testimonial`, value),
  changeStatus: (value) => AxiosInterceptor().post(`/testimonial/change-testimonial-status`, value),
};

export const locationServices = {
  getCountry: (values) => AxiosInterceptor().post(`/location/countries  `, values),
  getById: (values) => AxiosInterceptor().post(`/location/countryById`, values),
  add: (values) => AxiosInterceptor().post(`/location/country`, values),
  edit: (value) => AxiosInterceptor().post(`/location/country/update`, value),
  changeStatus: (value) => AxiosInterceptor().post(`/location/change-status`, value),
  getReferById: (values) => AxiosInterceptor().post(`/location/`, values),

  getState: (values) => AxiosInterceptor().post(`/location/states`, values),
  getByIdState: (values) => AxiosInterceptor().post(`/location/stateById`, values),
  addState: (values) => AxiosInterceptor().post(`/location/state`, values),
  editState: (value) => AxiosInterceptor().post(`/location/state/update`, value),

  getCities: (values) => AxiosInterceptor().post(`/location/cities`, values),
  getByIdCities: (values) => AxiosInterceptor().post(`/location/cityById`, values),
  addCities: (values) => AxiosInterceptor().post(`/location/city`, values),
  editCities: (value) => AxiosInterceptor().post(`/location/city/update`, value),

  deleteLocation: (value) => AxiosInterceptor().post(`/location/delete`, value),
};

export const vehicleServices = {
  getAllVehicles: (values) => AxiosInterceptor().post(`/getAllVehicle`, values),
  getVehicleById: (values) => AxiosInterceptor().post(`/getVehicleById`, values),
  addVehicle: (values) => AxiosInterceptor().post(`/createVehicle`, values),
  editVehicle: (value) => AxiosInterceptor().post(`/updateVehicle`, value),
  deleteVehicle: (value) => AxiosInterceptor().post(`/deleteVehicle`, value),
  changeStatus: (value) => AxiosInterceptor().post(`/vehicleStatus`, value),
  bulkUploadVehicles: (values) => AxiosInterceptor().post(`/vehicle/bulk-upload-vehicles`, values),
  getVehicleCategories: () => AxiosInterceptor().get(`/vehicle/get-vehicle-categories`),
  getVehicleStats: () => AxiosInterceptor().get(`/vehicle/get-vehicle-stats`),
  approveVehicle: (value) => AxiosInterceptor().post(`/approveVehicle`, value),
};
export const OrderServices = {
  getAllOrders: (values) => AxiosInterceptor().post(`/getAllOrders`, values),
  getOrderDetails: (values) => AxiosInterceptor().post(`/getOrderDetails`, values),
  updateOrderStatus: (values) => AxiosInterceptor().post(`/updateOrderStatus`, values),
  updateDeliveryType: (values) => AxiosInterceptor().post(`/updateDeliveryType`, values),
};

export const brandServices = {
  getAll: (values) => AxiosInterceptor().post(`/getAllBrands`, values),
  getBrandById: (values) => AxiosInterceptor().post(`/getBrandById`, values),
  add: (values) => AxiosInterceptor().post(`/createBrand`, values),
  edit: (value) => AxiosInterceptor().post(`/updateBrand`, value),
  deleteBrand: (value) => AxiosInterceptor().post(`/deleteBrand`, value),
  changeStatus: (value) => AxiosInterceptor().post(`/brandStatus`, value),
};

export const auctionServices = {
  getAllAuctions: (values) => AxiosInterceptor().post(`/getAllAuction`, values),
  getAuctionById: (values) => AxiosInterceptor().post(`/getAuctionById`, values),
  addAuction: (values) => AxiosInterceptor().post(`/createAuction`, values),
  editAuction: (value) => AxiosInterceptor().post(`/updateAuction`, value),
  deleteAuction: (value) => AxiosInterceptor().post(`/deleteAuction`, value),
  changeStatus: (value) => AxiosInterceptor().post(`/statusAuction`, value),
  cancelAuction: (value) => AxiosInterceptor().post(`/cancelAuction`, value),
  approveBid: (value) => AxiosInterceptor().post(`/approveBid`, value),
  rejectBid: (value) => AxiosInterceptor().post(`/rejectBid`, value),
  getAuctionStats: () => AxiosInterceptor().get(`/auction/get-auction-stats`),
  getAuctionTypes: () => AxiosInterceptor().get(`/auction/get-auction-types`),
  getVehiclesForAuction: () => AxiosInterceptor().get(`/auction/get-vehicles-for-auction`),
  scheduleAuction: (value) => AxiosInterceptor().post(`/scheduleAuction`, value),
  endAuction: (value) => AxiosInterceptor().post(`/endAuction`, value),
  getAuctionBids: (value) => AxiosInterceptor().post(`/getAuctionBids`, value),
  verifyDeposit: (value) => AxiosInterceptor().post(`/verifyDeposit`, value),
  getVehiclesWithoutAuctions: (value) => AxiosInterceptor().post(`/getVehiclesWithoutAuctions`, value),
};

export const FaqApi = {
  addFaq: (value) => AxiosInterceptor().post(`/addFaqs`, value),
  editFaq: (value) => AxiosInterceptor().post(`/addFaqs`, value),
  deleteFaq: (value) => AxiosInterceptor().post(`/deleteFaq`, value),
  getFaq: (values) => AxiosInterceptor().post(`/getAllFaqs`, values),
  getByIdFaq: (values) => AxiosInterceptor().get(`/getOneFaq/${values.id}`),

  changeStatusFaq: (values) => AxiosInterceptor().post(`/faqStatus`, values),
};

export const reportsServices = {
 

  shareEmail: (formData) => AxiosInterceptor().post(`/reports/shareEmail`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }),
};

export const apiSocialMediaManagement = {
  getAll: (values) => AxiosInterceptor().post(`/getAllSocialMedia`, values),
  getById: (values) => AxiosInterceptor().post(`/getSocialMediaById`, values),
  add: (values) => AxiosInterceptor().post(`/createSocialMedia`, values),
  edit: (value) => AxiosInterceptor().post(`/updateSocialMedia`, value),
  delete: (value) => AxiosInterceptor().post(`/deleteSocialMedia`, value),
  changeStatus: (value) => AxiosInterceptor().post(`/socialMediaStatus`, value),
};

  